import PropTypes from 'prop-types';
import React from 'react';
import PhaseType from 'types/phase';

const SendToStore = ({ event: { kind } }) =>
  <div className={kind}>
    Assessment/Refigure was uploaded to VG.
  </div>
;

// Original: References documents which we don't need right now, but will.

// const SendToStore = ({ event: { kind, data: { documents } } }) => {
//   const documentsString = documents.map(
      //  doc => `${doc.document_type} ${doc.document_name}`).join(', ');
//   return (
//     <div className={kind}>
//       {documentsString} assessment(s) was uploaded to VG.
//     </div>
//   );
// };

SendToStore.propTypes = {
  event: PropTypes.shape({
    kind: PropTypes.string.isRequired,
    data: PropTypes.shape({
      documents: PropTypes.array.isRequired,
    }).isRequired,
  }).isRequired,
  phase: PhaseType,
};

export { SendToStore as review_send_to_store, SendToStore as refigure_send_to_store };



// WEBPACK FOOTER //
// ./client/app/shared/components/PhaseHistoryCard/phaseEvents/send_to_store.jsx